import React, { Component } from 'react';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxExposition extends Component {

    static defaultProps = {
        label: "Exposition",
        placeholder: "Exposition",
    };


    render = () => {

        const fetchMethod = () => new Promise((resolve, reject) => {
            const expositions = ["E", "EO", "ESO", "N", "NE", "NES", "NO", "O", "ONE", "S", "SE", "SN", "SO", "SON"];
            resolve({ codeRetour: 0, reponseAPIobjet: expositions });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemKey={item => item}
            itemText={item => item}
        />;

    };

};